import React, {useContext, useEffect, useState} from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import CacheAndBank from "./CacheAndBank";
import SellType from "./SellType";
import ProvinceAndCity from "./ProvinceAndCity";
import FactorTypeSelect from "./FactorTypeSelect";
import PaymentTypeSelect from "./PaymentTypeSelect";
import TitlePriceTaxDiscount from "./TitlePriceTaxDiscount";
import {toast} from "react-toastify";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import numericFunction from "../../../utils/NumericFunction";
import SelectCustomer from "./SelectCustomer";
import {calculateTotalSum, isPaymentAndFactorSellSumEqual,} from "../SellFactorFunctions";
import sellFactorData from "../sellFactorData";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";
import OrderId from "./OrderId";
import CustomerName from "./CustomerName";
import CustomerMobile from "./CustomerMobile";
import CustomerAddress from "./CustomerAddress";
import CustomerPostalCode from "./CustomerPostalCode";
import CustomerUsedRemaining from "./CustomerUsedRemaining";

const SellFactorKOL = ({
                         sendData,
                         setSendData,
                         initialData,
                         componentData,
                         setComponentData,
                         setReRender
                       }) => {
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(true);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = new Date().toLocaleDateString("fa-IR", options);

  // data use in submit Form
  const setprint = useContext(SetPrintDataContext);
  const navigateTo = useNavigate();

  useEffect(() => {
    // Only run once on mount to set defaults
    if (sendData.date === "") {
      setSendData({date: todayDate});
    }
    if (
      sendData.factorType === "" ||
      sendData.factorType === undefined
    ) {
      setSendData({factorType: "factor"});
    }
  }, []);

  const submitHandler = (wannaPrint = 0) => {
    const temp = {...sendData};

    console.group('[SellFactorKOL] submitHandler called');
    console.log('paymentType:', sendData.paymentType);
    console.log('tableData length:', sendData.tableData?.length, sendData.tableData);
    console.log('priceData length:', sendData.priceData?.length);
    console.log('priceData:', JSON.parse(JSON.stringify(sendData.priceData || [])));
    console.log('full sendData:', JSON.parse(JSON.stringify(sendData)));
    console.groupEnd();

    if (temp.tableData.length === 0) {
      toast.error("فاکتور جز را پر کنید");
      return;
    }
    if (temp.paymentType === "cacheAndBank") {
      if (sendData.priceData.length === 0) {
        toast.error("فاکتور کل بدون مبلغ می باشد.");
        return;
      }
    }

    if (temp.paymentType === "cacheAndBank" && !isPaymentAndFactorSellSumEqual(sendData)) {
      toast.error("مبلغ پرداختی با مبلغ فاکتور برابر نیست!.");
      return;
    }

    if (temp.paymentType === "cacheAndBank" && calculateTotalSum(sendData).sum < 0) {
      toast.error("مبلغ کل نمیتواند منفی باشد.!.");
      return;
    }

    if (sendData?.usedRemaining > calculateTotalSum(sendData)) {
      toast.error("مبلغ کل نمیتواند منفی باشد.")
      return;
    }

    temp.date = numericFunction.p2e(temp.date);
    setIsSubmitButtonActive(false);
    toast("در حال ثبت فاکتور...");
    _axios.post(prefixUrl() + "/clothingShopFactor/", {
      request: "factorConfirm",
      factorData: temp,
    }).then((res) => {
      setIsSubmitButtonActive(true);
      const data = res.data;
      if (data.status) {
        toast.success(data.message);
        if (wannaPrint === 1) {
          let printData = {}
          printData = {
            type: "FactorPrint8cm",
            ...data.invoiceData,
          }
          setprint(printData);
          navigateTo("/factorprint");
        } else {
          setSendData({
            ...sellFactorData.initialSendData,
            serviceTitle: sendData.serviceTitle,
            servicePrice: sendData.servicePrice,
            city: sendData.city,
            province: sendData.province,
          });
          if (temp.mode === 'edit') {
            navigateTo(-1)
          } else {
            setReRender(Math.random() * 1300)
          }
        }
      } else {
        toast.error(data.message);
      }
    })
      .catch((err) => {
        console.log(err);
        setIsSubmitButtonActive(true);
      });
  };

  try {
    return (
      <>
        <div className="buy-fac-kol">
          <form onSubmit={(event) => {
            event.preventDefault();
            submitHandler(0);
          }}
                autoComplete={"off"}>
            <div className={`main-dyna-input solid-dyna-input`}>
              <label>تاریخ</label>
              <DatePicker
                onChange={(date) => {
                  if (date) {
                    setSendData({date: numericFunction.p2e(date.toLocaleString())});
                  } else {
                    setSendData({date: ""});
                  }
                }}
                calendar={persian}
                className="form-control"
                placeholder="تاریخ"
                locale={persian_fa}
                // value={sendData.date==="" ? "1" : sendData.date}
                value={sendData.date || todayDate}
                calendarPosition="bottom-right"
                hideOnScroll
              />
            </div>
            {sendData.showOrderId && <OrderId
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />}
            {sendData.factorType && <FactorTypeSelect
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />}
            <PaymentTypeSelect
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
            {sendData.paymentType === "cacheAndBank" ? (
              <CacheAndBank
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
            ) : sendData.paymentType === "debt" ? (
              <>
                <SelectCustomer
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </>
            ) : (
              <></>
            )}
            {/* اگه کلید ترو بود باید من نوع بستر فروش اینستاگرام تلگرام رو نشون بدم*/}
            {initialData.sellType && (
              <SellType
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
            )}

            {initialData?.customerClub &&
              <>
                <CustomerMobile
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
                <CustomerName
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
                {initialData?.addressAccess &&
                  <CustomerAddress
                    sendData={sendData}
                    setSendData={setSendData}
                    initialData={initialData}
                    componentData={componentData}
                    setComponentData={setComponentData}
                  />
                }
                {initialData?.postalCodeAccess &&
                  <CustomerPostalCode
                    sendData={sendData}
                    setSendData={setSendData}
                    initialData={initialData}
                    componentData={componentData}
                    setComponentData={setComponentData}
                  />
                }
                <CustomerUsedRemaining
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </>}

            {initialData.provinceAndCity && (
              <ProvinceAndCity
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
            )}
            <TitlePriceTaxDiscount
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />

            {<div className={'solid-dyna-input'} style={{height: "70px"}}>
              <label htmlFor="sendData__description">توضیحات</label>
              <textarea
                className={''}
                id={'sendData__description'}
                value={sendData.description}
                onChange={(e) => setSendData({description: e.target.value})}
                placeholder={"توضیحات "}
                name="hi"
              />
            </div>}

            <div className="grid-row" style={{paddingTop: '20px'}}>
              <input
                disabled={!isSubmitButtonActive}
                type="submit"
                className="btnCustom btnSubmit mt-5  py-5 w-100"
                value="ثبت فاکتور"
              />

              <button
                disabled={!isSubmitButtonActive}
                className="simple-but-no-bac"
                onClick={(event) => {
                  event.preventDefault();
                  submitHandler(1);
                }}>
                ثبت و پرینت
              </button>
            </div>
          </form>
        </div>
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(SellFactorKOL);
